import React, {useState, useEffect} from 'react';
import {
    EditorState,
    AtomicBlockUtils
} from 'draft-js';
import Popup from '../../../../bootstrap/components/popup/Popup';
import AudioPicker from '../../audio-picker/AudioPicker';
import {addRelationBetweenElements, RELATION_ADOPTED_CHILD} from "../../../../bootstrap/dom/element/relations";

export default function useAudio(editorState, setEditorState) {
    const [audioPickerShown, setAudioPickerShown] = useState(false);

    const [pickedAudios, setPickedAudios] = useState([]);

    const [insertedAudioIndex, setInsertedAudioIndex] = useState(null);

    useEffect(() => {
        if (insertedAudioIndex === null) {
            return;
        }

        if (pickedAudios.length <= insertedAudioIndex) {
            setInsertedAudioIndex(null);
            return;
        }

        insertAudioAtomicBlock(pickedAudios[insertedAudioIndex]);

        setInsertedAudioIndex(insertedAudioIndex + 1);
    }, [insertedAudioIndex]);

    useEffect(() => {
        setInsertedAudioIndex(0);
    }, [pickedAudios]);

    const insertAudioAtomicBlock = (audio) => {
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity(
            'AUDIO',
            'IMMUTABLE',
            audio
        );
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(editorState, {currentContent: contentStateWithEntity});

        setEditorState(AtomicBlockUtils.insertAtomicBlock(
            newEditorState,
            entityKey,
            audio.caption || audio.title || ' '
        ));
    };

    const timestamp = new Date().getTime();
    const audioButtonId = `__${timestamp}-rich-text-audio-button`;
    const audioPickerId = `__${timestamp}-rich-text-audio-picker`;

    useEffect(() => {
        const button = document.getElementById(audioButtonId);
        const picker = document.querySelector(`.${audioPickerId}-popup`);

        if (button && picker) {
            addRelationBetweenElements(RELATION_ADOPTED_CHILD, button, picker);
        }
    }, [audioPickerShown]);

    const audioButton = <button
        type="button"
        id={audioButtonId}
        onMouseDown={ev => {
            ev.preventDefault();
            setAudioPickerShown(true);
        }}
    >
        Audio
    </button>;

    const audioPicker = !audioPickerShown ? null : (
        <Popup name={audioPickerId}>
            <AudioPicker
                onDone={audios => {
                    setPickedAudios(audios);
                    setAudioPickerShown(false);
                }}
                onCancel={() => setAudioPickerShown(false)}
            />
        </Popup>
    );

    return [
        audioButton,
        audioPicker,
    ];
}
